<template>
  <div class="page_wrapper">
    <Page
      class="page_section"
      :current="currentNum"
      :page-size="pageSize"
      :total="totalNum"
      show-total
      @on-change="changePage"
    ></Page>
  </div>
</template>
<script>
export default {
  props: {
    totalNum: Number,
    pageSize: Number,
    currentNum: { type: Number, default: 1 }
  },
  data() {
    return {
      //        pageSize: 10, // 每页条数
      // currentNum: 1 // 当前页码
      //        totalNum: 150, // 数据总条数
    };
  },
  methods: {
    changePage(num) {
//      this.currentNum = num;
      this.$emit("pageCallback", { pageNum: num });
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/templates/Paging.vue